// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cardsGrid {
    display: flex;
     flex-direction: row ;
     justify-content: center;
     flex-wrap: wrap;
  }
  
  
  
  .card {
    margin :2px;
    width: 600px; 
    background-color: rgba(255, 255, 255, 0.7);
    border-radius: 10px;
    box-shadow:  0px 0px 3px 0px #42B0D5;
    font-family: 'Maersk Headline';
    border:1px solid #42B0D5;
    font-size: 12px;
  }
  @media (max-width: 1700px) {
  
    .card {
      
      width: 500px;  
    }
  }

  .tableCard {
    margin :2px;
    width: 600px; 
    background-color: rgba(255, 255, 255, 0.7);
    border-radius: 10px;
    box-shadow:  0px 0px 3px 0px #42B0D5;
    font-family: 'Maersk Headline';
    border:1px solid #42B0D5;
    font-size: 12px;
  }
  @media (max-width: 1700px) {
  
    .tableCard {
      
      width: 600px;  
      height: fit-content;
    }
  }`, "",{"version":3,"sources":["webpack://./src/styles/HomeGraphMetrics.css"],"names":[],"mappings":"AAAA;IACI,aAAa;KACZ,oBAAoB;KACpB,uBAAuB;KACvB,eAAe;EAClB;;;;EAIA;IACE,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,mBAAmB;IACnB,oCAAoC;IACpC,8BAA8B;IAC9B,wBAAwB;IACxB,eAAe;EACjB;EACA;;IAEE;;MAEE,YAAY;IACd;EACF;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,mBAAmB;IACnB,oCAAoC;IACpC,8BAA8B;IAC9B,wBAAwB;IACxB,eAAe;EACjB;EACA;;IAEE;;MAEE,YAAY;MACZ,mBAAmB;IACrB;EACF","sourcesContent":[".cardsGrid {\n    display: flex;\n     flex-direction: row ;\n     justify-content: center;\n     flex-wrap: wrap;\n  }\n  \n  \n  \n  .card {\n    margin :2px;\n    width: 600px; \n    background-color: rgba(255, 255, 255, 0.7);\n    border-radius: 10px;\n    box-shadow:  0px 0px 3px 0px #42B0D5;\n    font-family: 'Maersk Headline';\n    border:1px solid #42B0D5;\n    font-size: 12px;\n  }\n  @media (max-width: 1700px) {\n  \n    .card {\n      \n      width: 500px;  \n    }\n  }\n\n  .tableCard {\n    margin :2px;\n    width: 600px; \n    background-color: rgba(255, 255, 255, 0.7);\n    border-radius: 10px;\n    box-shadow:  0px 0px 3px 0px #42B0D5;\n    font-family: 'Maersk Headline';\n    border:1px solid #42B0D5;\n    font-size: 12px;\n  }\n  @media (max-width: 1700px) {\n  \n    .tableCard {\n      \n      width: 600px;  \n      height: fit-content;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
